<template>
  <div class="page-title">
    <div class="page-title-text">{{title || window.CONFIG.TITLE}}</div>
    <div class="sub-title" v-if="subTitle">{{subTitle}}</div>
    <base-account-info @clickUserName="clickUserName" style="position:absolute;right: 10px"></base-account-info>
    <base-dialog
      :input="user"
      :rules="{}"
      :width="'600px'"
      :title="'修改密码'"
      :dialogVisible.sync="dialog"
      @submit="confirmClick"
    >
      <el-form-item
        prop="loginPwd" label="新密码"
        :rules="[{required: true, message: '密码不能为空', trigger: 'blur'},{min:1,max:20,message:'字符长度必须在1-20之间',trigger: 'blur'}]">
        <el-input
          clearable v-model="user.loginPwd" for-test="user.loginPwd"
          type="password"
          placeholder="请输入新密码"></el-input>
      </el-form-item>
    </base-dialog>
  </div>
</template>
<style scoped lang="scss">

  .page-title {
    display: flex;
    height: 40px;
    align-items: center;
    position: relative;
    flex-shrink: 0;
    /*justify-content: space-between;*/
    /*background: -webkit-gradient(linear, left top, left bottom, from(#007E7D), to(#084A4C));*/
    /*background: linear-gradient(#007E7D, #084A4C);*/
    background: -webkit-gradient(linear, left top, left bottom, from(#081c31), to(#16486b));
    background: linear-gradient(#081c31, #16486b);

    .page-title-text {
      margin-left: 15px;
      font-size: 16px;
      font-weight: 600;
    }

    .sub-title {
      margin-left: 20px;
      line-height: 16px;
      font-size: 14px;
      font-weight: 400;
      position: relative;
      padding-left: 20px;
      color: #FFF;
      background-color: transparent;

      &::before {
        content: '';
        width: 13px;
        height: 13px;
        border-radius: 2px;
        background-color: #66e8e1;
        display: inline-block;
        position: absolute;
        top:1px;
        left: 0;
      }
    }
  }

</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/business-components/page-title/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/business-components/page-title/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/business-components/page-title/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-business-page-title')
  export default {
    name: 'business-page-title', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'business-page-title': require('%path').default,
       */
      /*start:import components file*/
'base-account-info': require('./../../base-components/account-info/index.vue').default,
       'base-back': require('./../../base-components/back/index.vue').default,
       'base-blackHandle': require('./../../base-components/blackHandle/index.vue').default,
       'base-bottomFloat': require('./../../base-components/bottomFloat/index.vue').default,
       'base-card-header': require('./../../base-components/card-header/index.vue').default,
       'base-carDriverInfo': require('./../../base-components/carDriverInfo/index.vue').default,
       'base-cascader-select-on-click': require('./../../base-components/cascader-select-on-click/index.vue').default,
       'base-check-all': require('./../../base-components/check-all/index.vue').default,
       'base-cropper': require('./../../base-components/cropper/index.vue').default,
       'base-datetimerange': require('./../../base-components/datetimerange/index.vue').default,
       'base-dialog': require('./../../base-components/dialog/index.vue').default,
       'base-empty': require('./../../base-components/empty/index.vue').default,
       'base-export': require('./../../base-components/export/index.vue').default,
       'base-filter': require('./../../base-components/filter/index.vue').default,
       'base-image-carousel': require('./../../base-components/image-carousel/index.vue').default,
       'base-img-base': require('./../../base-components/img-base/index.vue').default,
       'base-img-viewer': require('./../../base-components/img-viewer/index.vue').default,
       'base-key-value': require('./../../base-components/key-value/index.vue').default,
       'base-my-column': require('./../../base-components/my-column/index.vue').default,
       'base-number-input': require('./../../base-components/number-input/index.vue').default,
       'base-plate': require('./../../base-components/plate/index.vue').default,
       'base-quarter-datepicker': require('./../../base-components/quarter-datepicker/index.vue').default,
       'base-simple-menu': require('./../../base-components/simple-menu/index.vue').default,
       'base-yearrange': require('./../../base-components/yearrange/index.vue').default,
       /*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>